import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const trapezoidCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default trapezoidCommands;
